
import { HsbProjectsLoader } from './hsb-projectsloader';
import { NodeLoaderService } from './node-loader.service';
import { HsbProject } from './hsb-project';
import { HsbServerConfigService } from './hsbserver-config.service';
import { ObjectIDataDefinitionParserService } from './object-idata-definition-parser.service';
import { HsbModel, Units } from './hsbcad-model';
import { IProjectDB } from './iproject-db';
import { ProjectLoader } from './project-loader.service';

export class HsbProjectsCacheService {

    nodeLoaderService: NodeLoaderService = new NodeLoaderService();
    hsbServerConfigService: HsbServerConfigService = new HsbServerConfigService();
    projectLoader: ProjectLoader = new ProjectLoader();
    objectParserService: ObjectIDataDefinitionParserService = new ObjectIDataDefinitionParserService();

    hsbProjectsLoader: HsbProjectsLoader
    hsbLoadedProjects = {};
    private hsbViewer3dLoaded;
    private activeHsbProject: HsbProject | null = null;
    private _maxLoadedProjects: number = 2;
    public get maxLoadedProjects(): number {
        return this._maxLoadedProjects;
    }
    public set maxLoadedProjects(v: number) {
        this._maxLoadedProjects = Math.max(1, Math.min(v, 2));
    }

    constructor() {

        this.hsbProjectsLoader = new HsbProjectsLoader(this.projectLoader, this.nodeLoaderService, this.objectParserService);
    }
    getActivePoject() {
        return this.activeHsbProject;
    }

    getProjectDBs() {

        return this.hsbProjectsLoader.projectsDBs;
    }

    setProjectsCache(projectsDBs: Array<IProjectDB>) {

        this.hsbProjectsLoader.projectsDBs = projectsDBs;
    }

    findProjectDBFromName(projectName: String) {

        return this.hsbProjectsLoader.findProjectDBFromName(projectName);
    }

    findProjectDBFromID(projectID: String) {

        return this.hsbProjectsLoader.findProjectDBFromID(projectID);
    }
    isHsbProjectCached(projectItem: IProjectDB) {
        return (this.hsbLoadedProjects[projectItem.projectID]);
    }


    loadProject(projectItem, includeGeometry: boolean = true): Promise<HsbProject> {
        let _self = this;
        this.activeHsbProject = null;

        return new Promise(function (resolve, reject) {

            if (!projectItem)
                reject("HsbProjectsCacheService.loadProject(): No project item provided!");

            let projectID = projectItem.projectID;
            _self.activeHsbProject = projectItem;
            if (_self.hsbLoadedProjects[projectID]) {
                resolve(_self.hsbLoadedProjects[projectID]);
            } else {
                _self.hsbProjectsLoader.loadProjects(projectID, includeGeometry).then(projects => {

                    _self.hsbLoadedProjects[projectID] = projects[Object.keys(projects)[0]];
                    if (!_self.hsbLoadedProjects[projectID]) {
                        return reject("HsbProjectsCacheService.loadProject(): no project was found for the given id!");
                    }
                    _self.hsbLoadedProjects[projectID].projectItem = projectItem;
                    resolve(_self.hsbLoadedProjects[projectID]);
                }).catch(function (err) {
                    return reject(err);
                });
            }
        });
    }

    loadProjectNodeModel(projectItem): Promise<HsbProject> {
        let _self = this;

        return new Promise(function (resolve, reject) {

            if (!projectItem)
                reject("HsbProjectsCacheService.loadProjectNodeModel(): No project item provided!");

            let projectID = projectItem.projectID;

            _self.hsbProjectsLoader.loadProjects(projectID, false).then(projects => {

                let project = projects[Object.keys(projects)[0]];
                if (!project) {
                    return reject("HsbProjectsCacheService.loadProjectNodeModel(): No project found for given ID!");
                }
                resolve(project);
            }).catch(function (err) {
                return reject(err);
            });
        });
    }

    loadProjectID(projectID) {
        let _self = this;

        var promise = new Promise(function (resolve, reject) {

            if (_self.hsbLoadedProjects[projectID]) {
                resolve(_self.hsbLoadedProjects[projectID]);
            } else {
                _self.hsbProjectsLoader.loadProjects(projectID, true).then(projects => {

                    _self.hsbLoadedProjects[projectID] = projects[Object.keys(projects)[0]];
                    resolve(_self.hsbLoadedProjects[projectID]);
                }).catch(error => {
                    console.error('Error loading projects in project loader: ' + error.message, error)
                    reject(error);
                });
            }

        }).catch(error => {
            console.error('Error loading projects in cache service: ' + error.message, error);
        });

        return promise;
    }

    clearProjectsCache(projectID) {

        // Just remove  from this project from the cache to force a reload of the data so we don't have to refresh the browser.
        delete this.hsbLoadedProjects[projectID];
    }

    clearAllProjectsCache() {

        Object.keys(this.hsbLoadedProjects).forEach((key) => {
            delete this.hsbLoadedProjects[key];
        })
        this.hsbLoadedProjects = {};
        this.hsbProjectsLoader.clearHsbProjects();
    }

    reLoadProject(hsbProject) {

        let self = this;

        return new Promise(function (resolve, reject) {
            self.hsbProjectsLoader.reLoadProject(hsbProject).then(data => {
                resolve(true);
            }).catch(error => {
                reject('Error loading projects: ' + error);
            });
        });

    }

    migrateProject(hsbProject) {
        return this.hsbProjectsLoader.migrateProject(hsbProject)
    }

    loadGeometryBuffers(hsbProject) {
        return this.hsbProjectsLoader.loadGeometryBuffers(hsbProject)
    }

    createHfdmHsbModel(hfdmModelName, hsbProject) {
        let filename = hfdmModelName;
        var drawingName = filename;

        hsbProject.ProjectSource = "hsbcad";
        if (!hsbProject.HsbModels) {
            hsbProject.HsbModels = {};
        }

        if (drawingName && !hsbProject.HsbModels[drawingName]) {
            hsbProject.HsbModels[drawingName] = new HsbModel(drawingName);
            hsbProject.HsbModels[drawingName].DrawingName = drawingName;
            hsbProject.HsbModels[drawingName].modelId = drawingName;
            hsbProject.HsbModels[drawingName].Units = hsbProject?.Units ?? new Units('mm');;
            hsbProject.HsbModels[drawingName].FilePath = "";
            hsbProject.HsbModels[drawingName].ProjectSource = "hsbcad";
        }
    }

    AddHHfdmModelData(mapData, hsbModel, hsbProject) {
        var self = this;
        var mmproject = self.hsbProjectsLoader._modelmaploader.convertKeystoLowerCase(mapData);
        self.hsbProjectsLoader._modelmaploader.createCadModel(mmproject, hsbModel, hsbProject);
    }

    CreateHHfdmModelData(mapData, hsbModel) {
        var self = this;
        var mmproject = self.hsbProjectsLoader._modelmaploader.convertKeystoLowerCase(mapData);
        self.hsbProjectsLoader._modelmaploader.createCadModel(mmproject, hsbModel, null);
    }

    CreateHfdmNodeMMNodeModel(hsbModel, hsbProject) {
        this.hsbProjectsLoader._modelmaploader.createMMNodeModel(hsbModel, hsbProject);
    }

    ngOnDestroy() {

        this.hsbViewer3dLoaded.unsubscribe();
    }
}
